// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.companies-details-card {
  margin-top: 20px;
  border-radius: 20px;
  background-color: #e9e9e9;
  padding: 2rem;
  color: #434343;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 15px;
}

.company-name {
  font-size: 1.2rem;
  margin-bottom: 5px;
  font-weight: 500;
  /* flex-grow:1; */
}

.companies-details-card-details {
  margin-left: 5px;
}

.companies-details-single {
  margin-bottom: 10px;
}

.companies-details-single > p {
  margin: 0;
  padding: 0;
  margin-bottom: 5px;
  font-weight: bold;
}

.companies-details-card-details p {
  margin: 0;
  padding: 0;
  margin-left: 1.3rem;
}

.details-edit-icon {
  font-size: 1.2rem;
  cursor: pointer;
}

.date-input:disabled {
  border: none;
}

.date-input {
  border: none;
  background-color: white;
  border-radius: 100vh;
  padding: 2px 10px;
}

.date-fit {
  width: 10%;
}

.field-input:disabled {
  border: none;
}

.field-input {
  border: none;
  background-color: white;
  border-radius: 100vh;
  padding: 2px 10px;
}

.w-fit {
  width: 20%;
}

.btn-custom {
  border-radius: 100vh;
}

.input-custom {
  width: 100%;
}

.list-container {
  list-style-type: none;
  padding: 0;
}

.list-container li {
  display: flex;
  align-items: flex-start;
  /* Align items at the top */
  margin-bottom: 10px;
  /* Add some spacing between list items */
}

.list-container .bullet {
  margin-right: 10px;
  /* Adjust as needed to control the space between the bullet and textarea */
  font-size: 1.5rem;
  padding: 0;
  /* align-self: start; */
}

.list-container textarea {
  width: 100%;
  resize: vertical;
}

.extend {
  flex-grow: 1;
}

.textarea-custom {
  width: 100%;
  padding: 5px;
  border-radius: 5px;
}

.add-responsibility-icon {
  font-size: 1.2rem;
}

.add-responsibility-icon:hover {
  color: grey;
}

.cursor-pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../candidate/src/components/CandidateParse/ResumeEducationField.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,4CAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAGA;EACE,qBAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EAAyB,2BAAA;EACzB,mBAAA;EAAqB,wCAAA;AAEvB;;AAEA;EACE,kBAAA;EAAoB,0EAAA;EACpB,iBAAA;EACA,UAAA;EACA,uBAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,eAAA;AAEF","sourcesContent":[".companies-details-card {\n  margin-top: 20px;\n  border-radius: 20px;\n  background-color: rgb(233, 233, 233);\n  padding: 2rem;\n  color: rgb(67, 67, 67);\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 15px;\n}\n\n.company-name {\n  font-size: 1.2rem;\n  margin-bottom: 5px;\n  font-weight: 500;\n  /* flex-grow:1; */\n}\n\n.companies-details-card-details {\n  margin-left: 5px;\n}\n\n.companies-details-single {\n  margin-bottom: 10px;\n}\n\n.companies-details-single > p {\n  margin: 0;\n  padding: 0;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.companies-details-card-details p {\n  margin: 0;\n  padding: 0;\n  margin-left: 1.3rem;\n}\n\n.details-edit-icon {\n  font-size: 1.2rem;\n  cursor: pointer;\n}\n\n.date-input:disabled {\n  border: none;\n}\n\n.date-input {\n  border: none;\n  background-color: white;\n  border-radius: 100vh;\n  padding: 2px 10px;\n}\n\n.date-fit {\n  width: 10%;\n}\n\n.field-input:disabled {\n  border: none;\n}\n\n.field-input {\n  border: none;\n  background-color: white;\n  border-radius: 100vh;\n  padding: 2px 10px;\n}\n\n.w-fit {\n  width: 20%;\n}\n\n.btn-custom {\n  border-radius: 100vh;\n}\n\n.input-custom {\n  width: 100%;\n}\n\n\n.list-container {\n  list-style-type: none;\n  padding: 0;\n}\n\n.list-container li {\n  display: flex;\n  align-items: flex-start; /* Align items at the top */\n  margin-bottom: 10px; /* Add some spacing between list items */\n\n}\n\n.list-container .bullet {\n  margin-right: 10px; /* Adjust as needed to control the space between the bullet and textarea */\n  font-size: 1.5rem;\n  padding: 0;\n  /* align-self: start; */\n}\n\n.list-container textarea {\n  width: 100%;\n  resize: vertical;\n}\n\n.extend {\n  flex-grow: 1;\n}\n\n.textarea-custom {\n  width: 100%;\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.add-responsibility-icon {\n  font-size: 1.2rem;\n}\n\n.add-responsibility-icon:hover {\n  color: grey;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
